import { replace, push } from 'react-router-redux';
import { change } from 'redux-form';
import { getCategory } from '../selectors/categories-selectors';

export default categoryId => (dispatch, getState) => {
  const state = getState();
  const category = getCategory(state, categoryId);

  dispatch(replace(`/${category.slug}`));
  dispatch(push(`/${category.slug}/create-post`));
  dispatch(change('post', 'categoryId', categoryId));
  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./app/actions/change-category.js